// Action Types
export const FETCH_BATTLE_CARD_MP_REQUEST = "FETCH_BATTLE_CARD_MP_REQUEST";
export const FETCH_BATTLE_CARD_MP_SUCCESS = "FETCH_BATTLE_CARD_MP_SUCCESS";
export const FETCH_BATTLE_CARD_MP_FAILURE = "FETCH_BATTLE_CARD_MP_FAILURE";


// Action Creators
export const fetchBattleCardMpRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_BATTLE_CARD_MP_REQUEST,
      payload: {opportunityId},
    });
  };
};
export const fetchBattleCardMpSuccess = (data) => ({
  type: FETCH_BATTLE_CARD_MP_SUCCESS,
  payload: data,
});
export const fetchBattleCardMpFailure = (error) => ({
  type: FETCH_BATTLE_CARD_MP_FAILURE,
  payload: error,
});
